module.exports = __webpack_public_path__ + "img/set-complet-choco-shake.81f40b99.jpg";